const DATE_TO_SET = 'DATE_TO_SET';
const DATE_TO_SET_VALIDATION_MESSAGE = 'DATE_TO_SET_VALIDATION_MESSAGE';
const DATE_TO_SET_VISUALIZATION = 'DATE_TO_SET_VISUALIZATION';
const DATE_TO_SET_API_ERROR = 'DATE_TO_SET_API_ERROR';
const DATE_TO_SET_FOCUS = 'DATE_TO_SET_FOCUS';
const DATE_TO_BLURRED = 'DATE_TO_BLURRED';
const DATE_TO_FOCUSED = 'DATE_TO_FOCUSED';
const DATE_TO_CHANGE = 'DATE_TO_CHANGE';
const DATE_TO_DISABLE = 'DATE_TO_DISABLE';
const DATE_TO_SET_VALIDITY = 'EXPERIENCE_DATE_TO_SET_VALIDITY';

const experienceDateToSet = (value, date) => ({
  type: DATE_TO_SET,
  payload: {
    value,
    date
  }
});

const experienceDateToSetValidationMessage = (validationMessage) => ({
  type: DATE_TO_SET_VALIDATION_MESSAGE,
  payload: {
    validationMessage
  }
});

const experienceDateToSetVisualization = (markedAsWrong) => ({
  type: DATE_TO_SET_VISUALIZATION,
  payload: {
    markedAsWrong
  }
});

const experienceDateToSetApiError = (payload) => ({
  type: DATE_TO_SET_VISUALIZATION,
  payload
});

const experienceDateToSetFocus = (focus) => ({
  type: DATE_TO_SET_FOCUS,
  payload: {
    focus
  }
});

// eslint-disable-next-line max-params
const experienceDateToBlur = (validationMessage, date, dateFrom) => ({
  type: DATE_TO_BLURRED,
  payload: {
    validationMessage,
    date,
    dateFrom
  }
});

const experienceDateToFocus = (payload) => ({
  type: DATE_TO_FOCUSED,
  payload
});

const experienceDateToChange = (payload) => ({
  type: DATE_TO_CHANGE,
  payload
});

const experienceDateToDisable = (disabled) => ({
  type: DATE_TO_DISABLE,
  payload: {
    disabled
  }
});

const experienceDateToSetValidity = (valid) => ({
  type: DATE_TO_SET_VALIDITY,
  payload: {
    valid
  }
});

export {
  experienceDateToSetValidationMessage,
  experienceDateToSetVisualization,
  experienceDateToFocus,
  experienceDateToSetFocus,
  experienceDateToSetApiError,
  experienceDateToBlur,
  experienceDateToSet,
  experienceDateToChange,
  experienceDateToDisable,
  experienceDateToSetValidity,
  DATE_TO_SET_VALIDITY,
  DATE_TO_DISABLE,
  DATE_TO_CHANGE,
  DATE_TO_FOCUSED,
  DATE_TO_BLURRED,
  DATE_TO_SET_FOCUS,
  DATE_TO_SET_API_ERROR,
  DATE_TO_SET_VALIDATION_MESSAGE,
  DATE_TO_SET,
  DATE_TO_SET_VISUALIZATION
};

